export const name = 'stickyToComponent' as const
export { VSM_EDITOR_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
export const StickyToComponentSymbol = Symbol('StickyToComponent')
export const ShouldObserveHeaderHandlerSymbol = Symbol('ShouldObserveHeaderHandler')
